import { InstanceHelper } from "~/helpers/instanceHelper";

export default class Storager<T = any> {
  constructor(private key: string) {
  }

  set(value: T) {
    if (InstanceHelper.isString(value)) {
      localStorage.setItem(this.key, value)

      if (this.key === "formability:features") {
        document.cookie = `${this.key}=${value}`
      }
    } else {
      localStorage.setItem(this.key, JSON.stringify(value))

      if (this.key === "formability:features") {
        document.cookie = `${this.key}=${JSON.stringify(value)}`
      }
    }
  }

  get get(): T {
    return JSON.parse(localStorage.getItem(this.key)) as T
  }

  fetch(fallback: T): T {
    return this.get || fallback
  }
}